import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { Warning } from "@MeteoApi/models/Warning";
import { WarningType, priorityColor, warningIcon } from "@Utils/weatherWarning";
import classNames from "classnames";

type WeatherWarningIconProps = {
  type: WarningType;
  priority: Warning["priority"];
};

const WeatherWarningIcon = ({ type, priority }: WeatherWarningIconProps) => {
  const { t } = useTranslations();
  const WarningIcon = warningIcon[type];

  return (
    <div
      data-testid="weather-warning-icon"
      data-priority={priority}
      aria-hidden
      className={classNames(
        "m:size-6 m:rounded-sm",
        priorityColor(t)[priority].bg,
      )}>
      <WarningIcon fill={priorityColor(t)[priority].icon} />
    </div>
  );
};

export default WeatherWarningIcon;
